import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { tasks as tasksApi } from 'redux/modules/api'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api }) => ({
          local: {
            tasks: api.tasks.registrationAwardUnits
          }
        }),
        { ...tasksApi.registrationAwardUnits }
      )
    )

    class TasksRegistrationAwardUnits extends Component {
      static propTypes = {
        tasks: PropTypes.object,
        decoFilter: PropTypes.string,
        local: PropTypes.object.isRequired,
        getTasksRegistrationAwardUnits: PropTypes.func.isRequired,
        exportTasksRegistrationAwardUnits: PropTypes.func.isRequired
      }

      componentDidMount() {
        const { local } = this.props

        config.tasks &&
          this.handleGetTasksAwardUnits(local.tasks, this.handleGetBaseFilter())
      }

      componentWillReceiveProps(nextProps) {
        const { local } = this.props
        const { filter, limit, offset, sort } = nextProps.local.tasks

        if (
          local.tasks.filter !== filter ||
          local.tasks.limit !== limit ||
          local.tasks.offset !== offset ||
          local.tasks.sort !== sort
        ) {
          config.tasks &&
            this.handleGetTasksAwardUnits(
              nextProps.local.tasks,
              this.handleGetBaseFilter()
            )
        }
      }

      handleGetBaseFilter = () => {
        const { params, decoFilter } = this.props

        switch (decoFilter || config.filter) {
          case 'organizationAwardUnitsRegistrations':
            return `organization.id=${params && params.id}`
          case 'organizationIACsRegistrations':
            return `organization.id=${params && params.id}`
          default:
            return ''
        }
      }

      handleGetTasksAwardUnits = (tasks, baseFilter) =>
        this.props.getTasksRegistrationAwardUnits(tasks, baseFilter)

      handleExportAwardUnitsRegistrations = () => {
        const { local } = this.props

        return this.props.exportTasksRegistrationAwardUnits(
          local.tasks,
          this.handleGetBaseFilter()
        )
      }

      render() {
        const newProps = {
          ...this.props,
          tasks: {
            ...this.props.tasks,
            registrationAwardUnits: this.props.local.tasks
          },
          exportAwardUnitsRegistrations: this
            .handleExportAwardUnitsRegistrations,
          local: undefined
        }

        return <ComposedComponent {...newProps} />
      }
    }
    return enhance(TasksRegistrationAwardUnits)
  }
}

export default decorator
